import { ISelectInput } from '../../box/interfaces/select-input.interface';

export interface IFilterToApply {
  key?: string;
  alternateKey?: string;
  operator?: string;
  value?: ISelectInput[];
  selector?: string;
  argument?: string;
  toRemove?: boolean;
}
